import { LocalStorageKeys } from '@constants/enums';
import CloseIcon from '@mui/icons-material/Close';
import { Grid, IconButton, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import BgImage from './BgImage';
import Calculator from './Calculator';

const ConvertButton = () => {
  const { t } = useTranslation();
  const [shouldShow, setShouldShow] = useState(true);

  const handleDoNotShow = () => {
    localStorage.setItem(LocalStorageKeys.DO_NOT_SHOW_CONVERT, 'true');
    setShouldShow(false);
  };

  useEffect(() => {
    if (localStorage.getItem(LocalStorageKeys.DO_NOT_SHOW_CONVERT)) {
      setShouldShow(false);
    }
  }, []);

  const handleClose = () => {
    setShouldShow(false);
  };

  if (!shouldShow) {
    return null;
  }

  return (
    <Grid item xs={12}>
      <div className="flex flex-col justify-center items-center rounded-[20px] bg-[#D4E7FF] relative md:flex-row md:justify-between">
        <div className="self-center z-10 w-full md:max-w-lg md:ml-10 p-2">
          <Typography variant="h6" className="!font-medium">
            {t('convertTitle')}
          </Typography>
          <Typography variant="subtitle2" className="!font-normal">
            {t('convertSubtitle')}
          </Typography>
          <Typography
            variant="subtitle2"
            className="!text-[#006BF8] !font-normal underline hover:!text-[#034cab]"
            component="button"
            onClick={handleDoNotShow}
          >
            {t('convertHide')}
          </Typography>
        </div>
        <Calculator />
        <BgImage className="max-w-40 md:max-w-[unset] hidden md:block" />
        <IconButton
          className="!absolute top-2 right-2 z-20"
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
      </div>
    </Grid>
  );
};

export default ConvertButton;
